import qs from 'qs'

const fields = [
  'slug',
  'locale',

  'dateStart',
  'dateEnd',

  'title',

  'archived',

  'sortKey'
]

const sort = ['sortKey:asc']

const populate = {
  ...queryFragmentSeo,
  ...queryFragmentBlocks,
  ...queryFragmentEventEntries,
  ...queryFragmentExhibitionEntries,
  ...queryFragmentJournalEntries,
  ...queryFragmentPressEntries,
  ...queryFragmentPressKitEntries,
  coverImage: true
}

export const queryProjectEntryBySlug = (options: QueryBySlugOptions) => {
  const query = qs.stringify(
    {
      publicationState: options.publicationState || 'live',
      locale: options?.locale || 'nl-NL',
      filters: {
        slug: {
          $eq: options.slug
        }
      },
      fields: fields,
      populate: {
        localizations: {
          populate: populate
        },
        ...populate
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `project-entries?${query}`
}
